/**
 * Misma regla que `api/lib/telegramPlanTier.ts` (servidor):
 * **Basic vs VIP** para el grupo de Telegram no depende del proveedor de pago
 * (MercadoPago o Stripe), solo de `plan_tier` normalizado.
 */

export type TelegramPlanTier = "basic" | "vip";

export function normalizeTelegramPlanTier(
  raw: string | undefined | null,
): TelegramPlanTier {
  const t = String(raw ?? "basic").toLowerCase().trim();
  if (t === "vip" || t === "exclusive" || t === "miembro_vip") return "vip";
  return "basic";
}
